import React, { Component } from 'react';
import { Form, Input, Row, Col } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { isValidArray } from 'src/Library/Helper';
import useField, { useFieldProps } from 'src/hooks/form/useField';
import useInput from 'src/hooks/form/useInput';
import useMultiField from 'src/hooks/form/useMultiField';
import FieldNodeSingle from './FieldNodeSingle';
import { FieldNodeProps } from './form.types';
import useFieldGroup from 'src/hooks/form/useFieldGroup';

export type FieldNodeGroupRef = {
  field: any; //ReturnType<typeof useMultiField>;
  // children: React.ReactElement;
};

const FieldNodeGroup = (defaultNodes: any[]) =>
  React.forwardRef<FieldNodeGroupRef, FieldNodeProps & { requestRerender: () => void }>(
    ({ children, requestRerender, ...props }, ref) => {
      const field = useFieldGroup({
        defaultNodes,
        requestRerender,
        ...props,
      });

      if (ref) {
        (ref as any).current = { field };
      }

      return <>{children}</>;
      // return <>{field.render(render)}</>;
    }
  );

export default FieldNodeGroup;
